import React from "react";
import { Link } from "react-router-dom";

// Assist · Coaching mental : hub vers les outils Assist.
export default function AssistCoaching() {
  const cards = [
    {
      title: "Introspection",
      desc: "3 questions guidées pour clarifier tes ressentis.",
      to: "/assist/introspection",
    },
    {
      title: "Analyse",
      desc: "Arbre de décision + analyse guidée pour limiter les biais.",
      to: "/assist/analyse",
    },
    {
      title: "Décision",
      desc: "Utilise un arbre de décision pour objectiver tes choix.",
      to: "/assist/decisions",
    },
  ];

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <header className="space-y-2">
        <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-50 mb-4">Assist · Coaching mental</h1>
        <p className="text-sm md:text-base text-slate-600 dark:text-slate-300">
          Sessions guidées pour structurer ta réflexion, clarifier tes intentions et avancer pas à pas.
        </p>
      </header>

      <section className="grid gap-4 md:grid-cols-3 text-sm">
        {cards.map((c) => (
          <Link
            key={c.to}
            to={c.to}
            className="mm-surface p-4 hover:-translate-y-0.5 hover:shadow-md transition-transform"
          >
            <h2 className="text-lg font-semibold mb-1">{c.title}</h2>
            <p className="text-slate-600 dark:text-slate-300">{c.desc}</p>
          </Link>
        ))}
      </section>

      <section className="mm-surface p-4 space-y-2">
        <p className="text-sm text-slate-700 dark:text-slate-200">
          Bientôt : scénarios guidés, plans d'action, et feedback personnalisé.
        </p>
        {/* TODO MixMind: brancher ici l'interface Assist IA pour le coaching. */}
      </section>
    </div>
  );
}

